import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import {GelContentColumn, GelContentRow, Sanitize} from "cw-styleguide-react";
import {Link} from "react-router-dom";
import moment from "moment";

class DetailViewSchedule extends Component {
  render() {
    return <Fragment key={this.props.venue ? this.props.venue.id : 1}>

      {this.props.venue &&  <GelContentRow>
        <GelContentColumn xs={12} sm={3}>
          <p className={'gel-xs-mb-10'}>
            <strong>{this.props.t('view.detail.fields.venue.label')}:</strong>

          </p>
        </GelContentColumn>
        <GelContentColumn xs={12} sm={9}>
          <p>{this.props.venue.name}<br/><Link to={'#' + this.props.venue.id}
                                    data-link-accordion={this.props.venue.id}>{this.props.t('view.detail.fields.venue.view')}</Link>
          </p>
        </GelContentColumn>
      </GelContentRow>}


      {this.props.session.startDate &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.startDate.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <p>{moment(this.props.session.startDate).format('DD/MM/YYYY')}</p>
          </GelContentColumn>
        </GelContentRow>
      }

      {this.props.session.startDetails &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.startDetails.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <Sanitize html={this.props.session.startDetails} classes={['gel-xs-mb-20']}/>
          </GelContentColumn>
        </GelContentRow>
      }

      {this.props.session.daysTimes &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.daysTimes.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <Sanitize html={this.props.session.daysTimes} classes={['gel-xs-mb-20']}/>
          </GelContentColumn>
        </GelContentRow>
      }

      {!!this.props.session.studyMethodType.length &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.studyMethodType.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <p>{this.props.session.studyMethodType.map((type) => {
              return this.props.filters.studyMethodTypeLookup[type]
            }).join(', ')}</p>
          </GelContentColumn>
        </GelContentRow>
      }

      {!!this.props.session.studyMethodHours.length &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.studyMethodHours.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <p>{this.props.session.studyMethodHours.map((hours) => {
              return this.props.filters.studyMethodHoursLookup[hours]
            }).join(', ')}</p>
          </GelContentColumn>
        </GelContentRow>
      }

      {!!this.props.session.studyMethodTimes.length &&
        <GelContentRow>
          <GelContentColumn xs={12} sm={3}>
            <p className={'gel-xs-mb-10'}>
              <strong>{this.props.t('view.detail.fields.studyMethodTimes.label')}:</strong>
            </p>
          </GelContentColumn>
          <GelContentColumn xs={12} sm={9}>
            <p>{this.props.session.studyMethodTimes.map((time) => {
              return this.props.filters.studyMethodTimesLookup[time]
            }).join(', ')}</p>
          </GelContentColumn>
        </GelContentRow>
      }

      {/*if the venue has a contact then use it else use the session contact.*/}


      { this.props.venue && this.props.venue.contact && <GelContentRow>

        <GelContentColumn xs={12} sm={3}>
          <p className={'gel-xs-mb-10'}>
            <strong>{this.props.t('view.detail.fields.contactDetails.label')}:</strong>
          </p>
        </GelContentColumn>
        <GelContentColumn xs={12} sm={9}>
          <p>{this.props.venue.contact.name}</p>
          <p><a href={`mailto:${this.props.venue.contact.email}`} target="_blank" rel="noopener noreferrer">{this.props.venue.contact.email}</a></p>
            {this.props.venue.contact.telephoneNumber && <p><a href={`tel:${this.props.venue.contact.telephoneNumber}`} rel="noopener noreferrer">{this.props.venue.contact.telephoneNumber}</a></p>}
            {this.props.venue.contact.mobileNumber && <p><a href={`tel:${this.props.venue.contact.mobileNumber}`} rel="noopener noreferrer">{this.props.venue.contact.mobileNumber}</a></p>}
        </GelContentColumn>
      </GelContentRow>}

      { !this.props.venue.contact && this.props.session.contact && <GelContentRow>
        <GelContentColumn xs={12} sm={3}>
          <p className={'gel-xs-mb-10'}>
            <strong>{this.props.t('view.detail.fields.contactDetails.label')}:</strong>
          </p>
        </GelContentColumn>
        <GelContentColumn xs={12} sm={9}>
          <p>{this.props.session.contact.name}</p>
          {this.props.session.contact.email && <p><a href={`mailto:${this.props.session.contact.email}`} target="_blank" rel="noopener noreferrer">{this.props.session.contact.email}</a></p>}
          {this.props.session.contact.telephoneNumber && <p><a href={`tel:${this.props.session.contact.telephoneNumber}`} rel="noopener noreferrer">{this.props.session.contact.telephoneNumber}</a></p>}
          {this.props.session.contact.mobileNumber && <p><a href={`tel:${this.props.session.contact.mobileNumber}`} rel="noopener noreferrer">{this.props.session.contact.mobileNumber}</a></p>}
        </GelContentColumn>
      </GelContentRow>}

      <hr/>
    </Fragment>
  }


}

export default withTranslation('local')(DetailViewSchedule);
